import React from 'react';
import { Button, Well, Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from '../../components/Link';
import s from './Home.css';
import { pobierzListGmin } from '../../actions/gminy';
import ihubPhoto from './ihub2_photo.jpg';
import { headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';


const mapState = (state) => ({
  district: state.district.district,
  user: state.user,
  bounceCounter: state.style.bounceCounter,
  printModalStatus: state.printSettings.printModalStatus,
  fontSize: state.runtime.fontSize,
  messages: state.intl.messages,
  powiaty: state.powiaty,
  arePowiatyFetched: state.powiaty.arePowiatyFetched,
  gminy: state.gminy,
  areGminyFetched: state.gminy.areGminyFetched,
  districts: state.district.districts,
});
const mapDispatch = {
  pobierzListGmin,
};
const buttonStyle = {
  marginTop: '30px',
  marginBottom: '20px',
  height: '50px',
  width: '100%',
  borderRadius: '0',
  boxShadow: '0px 3px 14px -2px black',
  outline: 'none',
  // padding: '6px 18px 6px 18px',
};

class MenuRozwijane extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      colors: 'normal',
    };
  }

  componentDidMount() {
    this.updateTheme();
  }

  updateTheme() {
    const theme = getThemeFromLocalStorage();
    if (this.state.colors !== theme) {
      if (theme !== 'normal') {
        buttonStyle['color'] = headerStyle[theme].color;
        buttonStyle['backgroundColor'] = headerStyle[theme].backgroundColor;
      } else {
        buttonStyle['color'] = '';
        buttonStyle['backgroundColor'] = '';
      }
      this.setState({ colors: theme });
    }
  }

  render() {
    return (
      <div>
        <Button
          style={buttonStyle}
          bsSize="large"
          bsStyle="primary"
          onClick={() => this.setState({ open: !this.state.open })}
          aria-expanded={this.state.open}
          aria-controls="district-list"
        >
          <span className="glyphicon glyphicon-arrow-right" />
          <span style={{ margin: '0 20px' }}>Lista zarejestrowanych gmin</span>
          <span className="glyphicon glyphicon-arrow-left" />
        </Button>
        <Collapse in={this.state.open}>
          <div id="district-list">
            <Well style={{ background: buttonStyle.backgroundColor }}>
              {this.props.districts &&
                Object.keys(this.props.districts)
                  .sort()
                  .filter(item => this.props.districts[item].showOnList)
                  .map(item => (
                    <div key={item}>
                      <Link to={`/urzad/${this.props.districts[item].prefix}`}>
                        {this.props.districts[item].name}
                      </Link>
                    </div>
                  ))}
            </Well>
          </div>
        </Collapse>
      </div>
    );
  }  
}

class MainContent extends React.Component {
  render() {
    const districtsCount = Object.keys(this.props.districts).length;
    return <div style={{ minHeight: "650px", marginTop: "-80px" }}>
        <div className={s.container}>
          <div style={{ width: "100%", height: "auto", overflow: "hidden" }}>
            <img style={{ width: "100%" }} src={ihubPhoto} alt="Ihub Photo" />
          </div>
          {districtsCount > 1 ? <MenuRozwijane districts={this.props.districts}/> : null}
          <div>
            <p>
              <strong>Niniejszy portal</strong> to miejsce w sieci przygotowane z myślą o
              mieszkańcach poszczególnych gmin oraz przedsiębiorcach rozwijających swoją
              działalność na tych obszarach. Dzięki temu portalowi załatwienie sprawy jest możliwe całkowicie
              poprzez drogę elektroniczną.
            </p>
            
            <p>
              <strong>E-usługi</strong> to najszybsza i najwygodniejsza forma komunikacji
              Interesanta z Urzędem.
            </p>
            
            <p>
              Naszym celem jest usprawnienie klasycznego sposobu załatwiania spraw, związanego z
              wypełnianiem papierowych formularzy wniosków oraz z koniecznością osobistego
              stawienia się w Urzędzie. W tym celu wykorzystujemy najnowocześniejsze możliwości
              jakie daje Internet tak, aby kontakt z Urzędem był maksymalnie wygodny i szybki.
            </p>
            
            <p>
              Z poziomu portalu mają Państwo możliwość m.in.:
            </p>
            
            <ul>
              <li>Przeglądania katalogu usług dostępnych na platformie,</li>
              <li>Sprawdzenia informacji o sposobie załatwienia danej sprawy,</li>
              <li>Przesyłania wniosków w formie elektronicznych formularzy,</li>
              <li>Dokonywania płatności elektronicznych.</li>
            </ul>
            
            <p><strong>Jakie sprawy mogę załatwić?</strong></p>
            <p>
              Lista spraw dostępnych na portalu znajduje się w zakładce <a href={districtsCount > 1 ? "/euslugi" : `/urzad/${this.props.districts[Object.keys(this.props.districts)[0]].prefix}`} style={{ color: 'inherit', fontWeight: 'bold' }}>„Katalog E-USŁUG”</a>.
              Dla ułatwienia uzyskania informacji
              wyodrębniono dwie grupy: e-usługi niewymagające logowania oraz e-usługi wymagające
              logowania.
            </p>
            {districtsCount > 1 ?
              <p>Pełna lista urzędów świadczących e-usługi publiczne oraz lista e-usług
              poszczególnych urzędów znajduje się w zakładce <a href="/urzad" style={{ color: 'inherit', fontWeight: 'bold' }}>„Urzędy”</a>.
              </p>
            : null}

            <p>
              W celu uzyskania pełnego dostępu do wszystkich e-usług należy się <b>zalogować</b>.
            </p>
            
            <p>
              Więcej informacji na temat działania i rozwoju e-usług dowiesz się na stronie
              Ministerstwa Cyfryzacji pod adresem: <a target="_blank" rel="noopener noreferrer" href="https://mc.gov.pl/e-uslugi" style={{ color: 'inherit', fontWeight: 'bold' }}>
                https://mc.gov.pl/e-uslugi
              </a>
            </p>
          </div>
        </div>
      </div>;
  }
}

const Home = connect(mapState, mapDispatch)(MainContent);

export default withStyles(s)(Home);



// WEBPACK FOOTER //
// src/routes/home/Home.js